import { Space } from 'antd';
import { ReactNode } from 'react';
import Typography from 'antd/lib/typography/Typography';

type Props = {
    title: string;
    icon: ReactNode;
    content: ReactNode;
};

const FeatureGuidePanelSection = ({ title, icon, content }: Props) => {
    return (
        <section
            style={{
                fontSize: 14,
                lineHeight: '22px',
            }}
        >
            <Space size={2} direction="vertical" style={{ width: '100%' }}>
                <Space size={4}>
                    <span style={{ color: 'var(--brand-6)', fontSize: 16 }}>{icon}</span>
                    <Typography style={{ fontWeight: 600 }}>{title}</Typography>
                </Space>

                {content}
            </Space>
        </section>
    );
};

export default FeatureGuidePanelSection;
